import { http } from '../../config/axios'

export default function getCanaisNotificacao(): Promise<any> {
  return http
    .get('api/notificacao-fatura/canais')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getCanaisNotificacao', error)
      throw Error(error.response.data)
    })
}
